import Cookies from 'js-cookie'

export default {
  init() {
    /* eslint-disable */
    let cookies = Cookies.get('wmtm-favs');
    let favs = {};
    if(cookies) {
      console.log('parsing...');
      favs = JSON.parse(Cookies.get('wmtm-favs'));
    }
    if (!cookies || !favs) {
      console.log('settings...');
      favs = {};
      Cookies.set('wmtm-favs', JSON.stringify(favs));
    }

    $('.htheme-toggle-favorite').each((i, e) => {
      let postType = $(e).data('postType');
      let postId = $(e).data('postId');

      if (favs[postType] && favs[postType].includes(postId)) {
        $(e).attr('favorite', true);
        $(e).attr('title', 'Aus Favoriten entfernen.');
      }

      $(e).on('click', (ev) => {
        let btn = $(ev.target);

        let favs = JSON.parse(Cookies.get('wmtm-favs'));
        let postType = $(e).data('postType');
        let postId = $(e).data('postId');

        if (btn.attr('favorite') === 'true') {
          btn.attr('favorite', false);
          $(e).attr('title', 'Zu Favoriten hinzufügen.');
          $(e).attr('data-original-title', 'Zu Favoriten hinzufügen.');
          document.activeElement.blur();
        } else {
          btn.attr('favorite', true);
          $(e).attr('title', 'Aus Favoriten entfernen.');
          $(e).attr('data-original-title', 'Aus Favoriten entfernen.');
          document.activeElement.blur();
        }

        if (favs[postType] && favs[postType].includes(postId)) {
          favs[postType] = favs[postType].filter(item => item !== postId);
          if (favs[postType].length === 0) {
            delete favs[postType];
          }
          Cookies.set('wmtm-favs', JSON.stringify(favs));
        } else {
          if (favs[postType] === undefined) {
            favs[postType] = [postId]
          } else {
            favs[postType].push(postId);
          }
          Cookies.set('wmtm-favs', JSON.stringify(favs));
        }
      });

    });
  },
};



// WEBPACK FOOTER //
// ./scripts/htheme/favorites.js